// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Preloader_container__R8HpE {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #cccccc;
  text-align: center;
}

@keyframes Preloader_pulse__DNTbX {
  0% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
}

.Preloader_text__pzQdK {
  margin-top: 16px;
  font-size: 20px;
  font-weight: 700;
  color: white;
  animation: Preloader_pulse__DNTbX 1.6s infinite ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Preloader/Preloader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,2DAA0C;AAC5C","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  color: #cccccc;\n  text-align: center;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.6;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n  100% {\n    opacity: 0.6;\n    transform: scale(1);\n  }\n}\n\n.text {\n  margin-top: 16px;\n  font-size: 20px;\n  font-weight: 700;\n  color: white;\n  animation: pulse 1.6s infinite ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Preloader_container__R8HpE`,
	"text": `Preloader_text__pzQdK`,
	"pulse": `Preloader_pulse__DNTbX`
};
export default ___CSS_LOADER_EXPORT___;
